import ResourcePageGrid from "./ResourcePageGrid";

export default () => {
  return <ResourcePageGrid page="resources" />;
};
